<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.21967 4.21967C4.51256 3.92678 4.98744 3.92678 5.28033 4.21967L14.5 13.4393V9.24C14.5 8.82579 14.8358 8.49 15.25 8.49C15.6642 8.49 16 8.82579 16 9.24V15.25C16 15.6642 15.6642 16 15.25 16H9.24C8.82579 16 8.49 15.6642 8.49 15.25C8.49 14.8358 8.82579 14.5 9.24 14.5H13.4393L4.21967 5.28033C3.92678 4.98744 3.92678 4.51256 4.21967 4.21967Z"
            fill="currentColor"
        />
    </svg>
</template>
